module.exports = __webpack_public_path__ + "media/images/icons/information_block-45dd3406ccfad7829d67540d3e8d10cc.svg";